/*
 * student-header messages
 *
 * This contains all the text for the student-header component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    downloadTeacherRoll: {
        id: 'teacher-header.components.downloadTeacherRoll',
        defaultMessage: 'Download teacher roll'
    },
    quickUpload: {
        id: 'teacher-header.components.quickUpload',
        defaultMessage: 'Quick upload'
    },
    inviteTeacher: {
        id: 'teacher-header.components.inviteTeacher',
        defaultMessage: 'Invite teacher'
    },
    teachers: {
        id: 'teacher-header.components.teachers',
        defaultMessage: 'Teachers'
    },
    downloading: {
        id: 'teacher-header.components.downloading',
        defaultMessage: 'downloading'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-header/messages.js